<template>
  <div class="d-flex    justify-content-center card " style="margin-top: 50px">
    <div class="p-2    w-100 ">
      <div class="p-2">پیام خطا زمانی که صفحه رفرش میکند</div>

      <textarea v-model="from.refreshment" class="form-control" placeholder="متن پیام را وارد کنید"></textarea>
    </div>
    <div class="p-2    w-100 ">
      <div class="p-2">پیام خطا: زمانی که کاربر چند سوال را جواب نداد است</div>
      <textarea v-model="from.questionNoAnswered" class="form-control" placeholder="متن پیام را وارد کنید"></textarea>
    </div>
    <div class="p-2    w-100 ">
      <div class="p-2">پیام خطا: زمانی که سایت مشکل فنی دارد</div>
      <textarea v-model="from.technicalproblem" class="form-control" placeholder="متن پیام را وارد کنید"></textarea>
    </div>
    <div class="p-2    w-100 ">
      <div class="p-2">پیام خطا: زمانی که کاربر در آزمون قبول نشده و دوباره بدون در نظر گرفتن تاریخ اعلام شد دوباره قصد
        دارد در آزمون شرکت کند
      </div>
      <textarea v-model="from.notAcceptedRepetition" class="form-control"
                placeholder="متن پیام را وارد کنید"></textarea>
    </div>
    <div class="p-2    w-100 ">
      <div class="p-2">پیام خطا: زمانی که کاربر هیچ سوال را پاسخ نداده است این پیام خطا نمایش داده میشود</div>
      <textarea v-model="from.notAnswered" class="form-control" placeholder="متن پیام را وارد کنید"></textarea>
    </div>
    <div class="p-2    w-100 ">
      <label class="p-2  w-100">زمانی که کاربر صفحه رفرش میکند تا چند روز یا ساعت یا دقیقه دیگر دوباره حق شرکت در ازمون
        را دارد
      </label>
      <select v-model="from.dateRefreshment" class="btn btn-outline-danger col-lg-4">
        <option v-for="(row , i) in 1000" :value="row">{{ row }}</option>
      </select>
      <select v-model="from.methodDateRefreshment" class=" btn btn-outline-danger col-lg-2 ">
        <option value="time"> ساعت</option>
        <option value="day"> روز</option>
      </select>
    </div>
    <div class="p-2 w-100 ">
      <label class="p-2 w-100">زمانی که کاربر در آزمون نمره قبولی را نمی گیرد
      </label>
      <select v-model="from.dateNotAnswered" class="btn btn-outline-danger col-lg-4">
        <option v-for="(row , i) in 1000" :value="row">{{ row }}</option>
      </select>
      <select v-model="from.methodDateNotAnswered" class=" btn btn-outline-danger col-lg-2 ">
        <option value="time"> ساعت</option>
        <option value="day"> روز</option>
      </select>
    </div>
    <br>
    <div class="p-2 w-100">
      <button @click="btnClick" class="form-control  btn btn-success"> ثبت تظیمات</button>
    </div>
  </div>
</template>
<script setup>

import {useToast} from "vue-toastification";
import {reactive} from "vue";
import  {$ref} from "vue/macros";
import axios from "axios";
import config from "../../../../config/config.json";
// import {$ref} from "vue/macros";

const from = reactive({
  refreshment: "",
  questionNoAnswered: "",
  technicalproblem: "",
  notAnswered: "",
  notAcceptedRepetition: "",
  dateRefreshment: "",
  methodDateRefreshment: "",
  dateNotAnswered: "",
  methodDateNotAnswered: ""
})
const url = config.BASE_URL + "/settings";
let lists = $ref({});
function getData() {
  axios.get(config.BASE_URL + '/settings')
      .then(function (response) {
        let res = response.data;
        if (res.status === 'true') {
          lists = res.data;
          from.refreshment = lists[0]['refreshment'];
          from.questionNoAnswered = lists[0]['questionNoAnswered']
          from.technicalproblem = lists[0]['technicalproblem']
          from.notAnswered = lists[0]['notAnswered']
          from.notAcceptedRepetition = lists[0]['notAcceptedRepetition']
          from.dateRefreshment = lists[0]['dateRefreshment']
          from.methodDateRefreshment = lists[0]['methodDateRefreshment']
          from.dateNotAnswered = lists[0]['dateNotAnswered']
          from.methodDateNotAnswered = lists[0]['methodDateNotAnswered']
        }
      })
}
getData();
function btnClick() {
  const toast = useToast();
  axios.post(url, {
    refreshment: from.refreshment,
    questionNoAnswered: from.questionNoAnswered,
    technicalproblem: from.technicalproblem,
    notAnswered: from.notAnswered,
    notAcceptedRepetition: from.notAcceptedRepetition,
    dateRefreshment: from.dateRefreshment,
    methodDateRefreshment: from.methodDateRefreshment,
    dateNotAnswered: from.dateNotAnswered,
    methodDateNotAnswered: from.methodDateNotAnswered
  })
      .then(function (res) {
        if (res.data.status === 'true') {
          toast.success(res.data.messages);
          return "";
        }
      }).catch(function (errors) {
    // console.log(errors);
    if (errors.response.status === 422) {
      Object.values(errors.response.data.errors).forEach(function (val, key) {
        toast.error(val[0]);
      });
    }
    if (errors.response.status === 404) {
      toast.error(errors.response.data.messages);
    }
  });
}


</script>






















